import React, { ReactNode } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';

interface FadeInComponentProps {
  children: ReactNode;
  fromBottom?: boolean;
  delay?: number;
  duration?: number;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
}

const AnimatedFadeInComponent: React.FC<FadeInComponentProps> = ({
  children,
  id,
  fromBottom = false,
  delay = 150,
  duration = 500,
  className,
  style = {},
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const translateY = fromBottom ? 'translateY(20px)' : 'translateY(0)';

  const fadeIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : translateY,
    config: { mass: 1, tension: 210, friction: 20, duration },
    delay,
  });

  return (
    <animated.div ref={ref as React.Ref<HTMLDivElement>} style={{ ...fadeIn, ...style }} key={id} className={className}>
      {children}
    </animated.div>
  );
};

export default AnimatedFadeInComponent;
